const situations = [
  'договаривается с сотрудником о результате и ответственности;',
  'распределяет ответственность между участниками;',
  'обсуждает сроки и их изменение;',
  'требует выполнения принятых обязательств;',
  'согласовывает ресурсы и приоритеты;',
  'отстаивает бюджет своего подразделения;',
  'обсуждает KPI и показатели;',
  'договаривается с другим подразделением;',
  'защищает интересы своего отдела;',
  'разговаривает с собственником о стратегии и ресурсах;',
  'согласовывает решение с генеральным директором;',
  'обсуждает условия с партнёром;',
  'участвует в ключевых переговорах с клиентом;',
  'разрешает конфликт интересов.',
];

export default function WhyManagerNegotiates() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему руководитель оказывается в переговорах чаще, чем кажется
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Переговоры руководителя — это далеко не только официальные встречи за столом. Руководитель ведёт переговоры ежедневно, когда:
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto mb-12">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-arrow-right-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Руководитель может иметь полномочия, но переговоры начинаются там, где интересы сторон не совпадают полностью.
          </p>
        </div>
      </div>
    </section>
  );
}